import React, { memo } from 'react'

import RedeemPointsConfirm from '../../../components/popups/redeem/RedeemPointsConfirm'

const RedeemConfirmWrapper = (props) => {
  return <RedeemPointsConfirm {...props} />
}

export default memo(RedeemConfirmWrapper)
